import http from "./http";

const checkUrl = (params) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.append(key, value);
    }
  });
  return query.toString();
};

export const fetchCategories = () => {
  return http.get("/reference/club-category");
};

export const fetchTopOrganizations = (params) => {
  return http.get("/landing/main/top-organizations", { params });
};

export const fetchTopTeachers = (params) => {
  return http.get("/landing/main/top-teachers", { params });
};

export const fetchAllCourses = (params) => {
  const query = checkUrl(params);
  return http.get(`/landing/course?${query}`);
};

export const fetchCourseInfo = (params) => {
  return http.get(`/landing/course/${params.courseId}`);
};

export const fetchOrganizations = (params) => {
  const query = checkUrl(params);
  return http.get(`/landing/branch?${query}`);
};
export const fetchOrganizationInfo = (params) => {
  return http.get(`/landing/branch/${params.centerId}`);
};

export const fetchVacancy = (params) => {
  const query = checkUrl(params);
  return http.get(`/landing/vacancy?${query}`);
};

export const fetchPrivateLessons = (params) => {
  const query = checkUrl(params);
  return http.get(`/landing/private-lesson?${query}`);
};

export const fetchRegions = (params) => {
  return http.get("/reference/punkt", { params });
};
export const fetchLanguages = (params) => {
  return http.get("/reference/language", { params });
};
export const fetchSocialCategories = (params) => {
  return http.get("/reference/social-category", { params });
};

export const fetchAllSportCourses = (params) => {
  const query = checkUrl(params);
  return http.get(`/landing/sport-course?${query}`);
};
export const fetchSportCourseInfo = (params) => {
  return http.get(`/landing/sport-course/${params.courseId}`);
};

export const fetchAllCultureCourses = (params) => {
  const query = checkUrl(params);
  return http.get(`/landing/culture-course?${query}`);
};

export const fetchCultureCourseInfo = (params) => {
  return http.get(`/landing/culture-course/${params.courseId}`);
};

export const getFavorites = (params) => {
  const query = checkUrl(params);
  return http.get(`/landing/parent/favorites?${query}`);
};

export const getFavoritesList = () => {
  return http.get("/landing/parent/favorites/list");
};

export const addToFavorites = (cardId) => {
  return http.post(`/landing/course/${cardId}/favorite`);
};

export const removeFromFavorites = (cardId) => {
  return http.delete(`/landing/course/${cardId}/favorite`);
};

export const uploadFile = (formData) => {
  return http.post('/file/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
};

export const getFile = (path) => {
  return http.get('/file/get-base64', {
    params: {
      file_path: path
    }
  });
};

export const getAboutInfo = (params) => {
  return http.get("/landing/main/get-about-info", { params });
};